import { css } from 'lit-element';

export const kwWrapperEventsStyles = css`
  :host {
    display: block;
    --section-margin-bottom: var(--section-content-margin-bottom, 70px);
    --column-gap: 33px;
  }
  .kw-wrapper-events__container--coming-soon-events {
    margin-bottom: calc(var(--section-margin-bottom) + 30px);
  }
  .kw-wrapper-events__container--now-events,
  .kw-wrapper-events__list--past-events {
    margin-bottom: var(--section-margin-bottom);
  }
  .kw-wrapper-events__list--now-events,
  .kw-wrapper-events__list--past-events {
    display: grid;
    column-gap: var(--column-gap);
  }
  .kw-wrapper-events__list--now-events {
    grid-template-columns: repeat(2, 1fr);
  }
  .kw-wrapper-events__list--past-events {
    grid-template-columns: repeat(4, 1fr);
  }
  .kw-wrapper-events__list--past-events:last-child {
    margin-bottom: 50px;
  }
  kw-title {
    display: block;
    text-transform: capitalize;
    margin-bottom: 48px;
  }

 
  @media all and (min-width: 768px) {
    .desktop-hidden {
      display: none;
    }

    .kw-cards__opacity {
      opacity: 0;
    }

    .kw-cards__animate {
      opacity: 1;
      animation: scaleMoveUp 2s;
      transition-property: opacity;
      transition-duration: 2s;
      transition-timing-function: ease-out;
  }
    @keyframes scaleMoveUp {
      0% {
          transform: translateY(300px)
      }
      100% {
          transform: translateY(0)
      }
  }

  

}

   
  @media all and (max-width: 768px){
    .kw-wrapper-events__list--past-events{
      display: flex;
      flex-direction: column;
    }
    .kw-wrapper-events__list--now-events{
      display: flex;
      flex-direction: column;
    }
    .kw-wrapper-events__container--coming-soon-events {
      margin-bottom: 16px;
    }
    .p-hidden {
      display: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .kw-cards__animate {
      animation-name: none;
      transition-property: none ;
      transition-duration: 0.001ms ;
      transition-timing-function: unset ;
    }

    .kw-cards__opacity {
      opacity: 1;
    }
  }
`;
